// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { socialMediaCardStyles } from "@synd/App/Components/SocialMediaCard/SocialMediaCard";
import { xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

socialMediaCardStyles.cardContainer = {
    cardDivider: {
        css: css`
            border: 0;
        `,
    },
};

socialMediaCardStyles.image = {
    width: "240px",
    height: "240px",
    css: css`
        object-fit: contain;
        border-radius: 8px;

        ${xScreen("lte", "sm")} {
            width: 172px;
            height: 172px;
        }
    `,
};
